/**
 * PanelWeights — N labelled weights that read as PROPORTIONS.
 *
 * The raw numbers are meaningless on their own ([5, 3, 2] and [50, 30, 20] are the same world), so
 * the readout is each weight over the sum. Small, but the alternative is the world dialog growing
 * its own bespoke control again, which is the thing the kit exists to stop.
 */

import { PanelRow } from './Panel';
import { PanelSlider } from './PanelSlider';

interface PanelWeightsProps {
  options: readonly { value: string; label: string }[];
  weights: readonly number[];
  onChange: (weights: number[]) => void;
  max?: number;
}

export function PanelWeights({ options, weights, onChange, max = 10 }: PanelWeightsProps) {
  const total = weights.reduce((a, b) => a + b, 0) || 1;
  return (
    <div className="flex flex-col gap-1">
      {options.map((o, i) => (
        <PanelRow key={o.value} label={o.label} value={`${Math.round((weights[i] ?? 0) / total * 100)}%`}>
          <PanelSlider
            min={0} max={max} step={1} value={weights[i] ?? 0}
            onChange={(v) => onChange(options.map((_, j) => (j === i ? v : weights[j] ?? 0)))}
            ariaLabel={o.label}
          />
        </PanelRow>
      ))}
    </div>
  );
}
